/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgIcon } from "../shared/SvgIcon";
var ListChecksOutlineIcon = function ListChecksOutlineIcon(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M5.82844 8.07113L3.70712 5.94981L2.29291 7.36403L5.82844 10.8996L11.4853 5.2427L10.0711 3.82849L5.82844 8.07113Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82844 17.0711L3.70712 14.9498L2.29291 16.364L5.82844 19.8996L11.4853 14.2427L10.0711 12.8285L5.82844 17.0711Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 10H12V8.00001H20V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18H12V16H20V18Z"
  }));
};
export default ListChecksOutlineIcon;